import React, { forwardRef } from 'react';

import { useMergeRefs } from '@floating-ui/react';
import { usePopoverContext } from './usePopoverContext';

import WpPopoverOverlay from './WpPopoverOverlay';

// Styles
import './WpPopoverContent.scss';

const WpPopoverContent = forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(function WpPopoverContent(
  { children },
  propRef
) {
  const context = usePopoverContext();
  const ref = useMergeRefs([context.refs.setFloating, propRef]);

  if (!context.open) return null;

  return (
    <WpPopoverOverlay context={context} ref={ref}>
      {children}
    </WpPopoverOverlay>
  );
});

export default WpPopoverContent;
